import AppBar from '@material-ui/core/AppBar';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import * as React from 'react';
import { BrowserRouter as Router, Link, Route, withRouter } from "react-router-dom"
import './App.css';
import { Home } from './components/Home';
import { Schedule } from './components/Schedule';
import { Sponsor } from './components/Sponsor';
import { Volunteer } from './components/Volunteer';

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#174135'
    },
  }
});

const styles = {
  stickToBottom: {
    bottom: 0,
    position: 'fixed' as 'fixed',
    width: '100%',
  },
};

class App extends React.Component<{ history: any, location: any }, { value: any, title: string }> {

  private unsubscribeFromHistory: any;

  constructor(props: any) {
    super(props);

    this.state = {
      title: this.getTitle(props.location.pathname),
      value: this.getTabIndex(props.location.pathname),
    };

    this.setValue = this.setValue.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  public componentDidMount() {
    const { history } = this.props;
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    this.handleLocationChange(history.location);
  }

  public componentWillUnmount() {
    if (this.unsubscribeFromHistory) {
      this.unsubscribeFromHistory();
    };
  }

  public handleLocationChange(updatedLocation: any) {
    const { location } = this.props;

    if (updatedLocation.pathname === location.pathname) { return; }

    this.setState({ title: this.getTitle(updatedLocation.pathname) });
  }

  public setValue(value: any) {
    this.setState({ value });
  }

  public render() {
    const { title, value } = this.state;

    return (
      <div className="app">
        <AppBar position="fixed">
          <Toolbar>
            <Typography variant="h6">
              FunFest 2019<br />
              <p className="subtitle">{title}</p>
            </Typography>
          </Toolbar>
        </AppBar>
        <Container className="view">
          <Route path="/" exact={true} component={Home} />
          <Route path="/schedule" exact={true} component={Schedule} />
          <Route path="/sponsor" exact={true} component={Sponsor} />
          <Route path="/volunteer" exact={true} component={Volunteer} />
        </Container>
        <BottomNavigation
          style={styles.stickToBottom}
          className="MuiPaper-elevation4"
          value={value}
          onChange={(event, value) => this.setValue(value)} // tslint:disable-line
          showLabels={true}
        >
          <BottomNavigationAction icon={<HomeIcon />} component={Link} to="/" />
          <BottomNavigationAction icon={<CalendarIcon />} component={Link} to="/schedule" />
          <BottomNavigationAction icon={<PeopleIcon />} component={Link} to="/volunteer" />
          <BottomNavigationAction icon={<StoreIcon />} component={Link} to="/sponsor" />
        </BottomNavigation>
      </div>
    );
  }

  private getTitle(path: string): string {
    switch (path) {
      case '/':
        return 'Home';
      case '/schedule':
        return 'Schedule';
      case '/volunteer':
        return 'Volunteer';
      case '/sponsor':
        return 'Sponsors';
      default:
        return '';
    }
  }

  private getTabIndex(path: string): number {
    switch (path) {
      case '/':
        return 0;
      case '/schedule':
        return 1;
      case '/volunteer':
        return 2;
      case '/sponsor':
        return 3;
      default:
        return 0;
    }
  }

}

const Wrapped = withRouter(App);

export default function main() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Wrapped />
      </Router>
    </ThemeProvider>
  );
}



// WEBPACK FOOTER //
// ./src/App.tsx